import { useMemo, useState, useEffect, useCallback } from 'react';

import { CustomerRail } from './CustomerRail';
import { InsightsShellContext } from './shell';
import { useAppDispatch } from '../../app/hooks';
import { InsightsTopBar } from './InsightsTopBar';
import { TooltipProvider } from '../../ui/Tooltip';
import { UpdateSnackbar } from '../../components/UpdateSnackbar';
import { dashboardClosed, dashboardOpened } from '../../store/slices/coachInsights';

// Three-panel shell from the DUSQ Figma: top bar, customer rail, page (center + right panel).
const InsightsLayout = ({ children }) => {
  const dispatch = useAppDispatch();
  const [railOpen, setRailOpen] = useState(false);
  const closeRail = useCallback(() => setRailOpen(false), []);
  const shell = useMemo(() => ({ railOpen, setRailOpen }), [railOpen]);

  useEffect(() => {
    dispatch(dashboardOpened());
    return () => dispatch(dashboardClosed());
  }, [dispatch]);

  return (
    <TooltipProvider delayDuration={250}>
      <InsightsShellContext.Provider value={shell}>
        <div className="flex h-screen w-full flex-col overflow-hidden bg-dq-bg font-dq leading-[normal] text-dq-title">
          <InsightsTopBar />
          <div className="flex min-h-0 flex-1">
            <CustomerRail open={railOpen} onClose={closeRail} />
            <div className="flex min-w-0 flex-1 flex-col">{children}</div>
          </div>
          <UpdateSnackbar />
        </div>
      </InsightsShellContext.Provider>
    </TooltipProvider>
  );
};

export default InsightsLayout;
